import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PortalChoice from "@/pages/PortalChoice";
import PortalGate from "@/pages/PortalGate";
import Preview from "@/pages/Preview";
import AnaPage from "@/pages/AnaPage";
import AnaExecutive from "@/pages/AnaExecutive";
import LivingWithCancerPage from "@/pages/LivingWithCancerPage";
import PitchDeck from "@/pages/PitchDeck";
import InsightsPage from "@/pages/InsightsPage";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortalChoice />} />
          <Route path="/ana-access" element={<PortalGate portal="ana" />} />
          <Route path="/investor-access" element={<PortalGate portal="investor" />} />
          <Route path="/investor" element={<Preview />} />
          <Route path="/investor/deck" element={<PitchDeck />} />
          {/* Public shareable deck link for VCs — no password required */}
          <Route path="/deck" element={<PitchDeck publicAccess />} />
          {/* Private founder dashboard — admin key required */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/ana" element={<AnaPage />} />
          <Route path="/ana/full" element={<AnaPage />} />
          <Route path="/ana/exec" element={<AnaExecutive />} />
          <Route path="/living-with-cancer-access" element={<PortalGate portal="living-with-cancer" />} />
          <Route path="/living-with-cancer" element={<LivingWithCancerPage />} />
          {/* Legacy redirect */}
          <Route path="/investor-preview" element={<Navigate to="/investor" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
